import website from '@/config/website';
import store from '@/store/index'
export const option = {
  height: 500,
  lazy: true,
  tip: false,
  simplePage: true,
  searchShow: true,
  searchMenuSpan: 6,
  tree: true,
  border: true,
  index: true,
  selection: false,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  labelWidth: 150,
  searchLabelWidth: 100,
  menuWidth: 300,
  dialogClickModal: false,
  column: [
    {
      label: '代理商简称',
      prop: 'deptId',
      type: 'select',
      filterable: true,
      multiple: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
      display: false,
    },
    {
      label: '代理级别',
      prop: 'agentLevel',
      display: true,
      type: 'select',
      search: true,
      order: 10,
      hide: false,
      maxlength: 2,
      dicData: [
        {
          label: '省代',
          value: 0
        },
        {
          label: '市代',
          value: 1
        },
        {
          label: '一般代理',
          value: 2
        }
      ],
      rules: [
        {
          required: true,
          // message: '请选择代理级别',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请选择代理级别'))
            } else {
              callback()
            }
          }
        },
      ],
    },
    {
      label: '地区',
      display: false,
      prop: 'che300CityName',
      // type: 'input',
      search: false,
      order: 11,
      formatter: (val, value, label) => {
        return val.che300CityName ? val.che300CityName : '-'
      }
      // maxlength: 8,
      // addDisplay: false,
      // editDisplay: false,
    },
    {
      label: '省份',
      prop: 'provinceCode',
      props: { label: 'title', value: 'id' },
      type: 'select',
      hide: true,
      search: true,
      cascader: ['cityCode'],
      dicUrl: `/api/blade-system/region/lazy-tree?parentCode=00`,
      rules: [
        {
          required: true,
          message: '请选择省份',
          trigger: 'change',
        },
      ],
    },
    {
      label: '城市',
      prop: 'cityCode',
      props: { label: 'title', value: 'id' },
      type: 'select',
      hide: true,
      search: true,
      dicUrl: `/api/blade-system/region/lazy-tree?parentCode={{key}}`,
      rules: [
        {
          required: true,
          message: '请选择城市',
          trigger: 'change',
        },
      ],
    },
    {
      label: '代理商简称',
      prop: 'deptName',
      search: false,
      order: 999,
      maxlength: 50,
      rules: [
        {
          required: true,
          message: '请输入代理商简称',
          trigger: 'blur',
        },
        // {
        //   pattern: /(?<=分公司|集团)$/,
        //   message: "请以'分公司'或'集团'为结尾",
        //   trigger: "blur",
        // },
      ],
    },
    {
      label: '所属租户',
      prop: 'tenantId',
      display: false,
      // type: 'tree',
      dicUrl: '/api/blade-system/tenant/select',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: website.tenantMode,
      span: 24,
      props: {
        label: 'tenantName',
        value: 'tenantId',
      },
      hide: !website.tenantMode,
      search: website.tenantMode,
      rules: [
        {
          required: true,
          message: '请输入所属租户',
          trigger: 'click',
        },
      ],
    },
    {
      label: '代理商全称',
      prop: 'fullName',
      search: false,
      order: 998,
      maxlength: 50,
      rules: [
        {
          required: true,
          message: '请输入代理商全称',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '历史保证金抵扣',
      prop: 'historicalMarginDeduction',
      type: 'number',
      hide: true,
      display: false,
      showColumn: false,
      rules: [
        {
          required: false,
          type: 'number',
          min: 0,
          message: '请输入历史保证金抵扣',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '历史保证金存量',
      prop: 'historicalMarginStock',
      type: 'number',
      hide: true,
      display: false,
      showColumn: false,
      rules: [
        {
          required: false,
          type: 'number',
          min: 0,
          message: '请输入历史保证金存量',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '上级代理商',
      prop: 'parentId',
      display: false,
      dicData: [],
      // type: 'tree',
      hide: true,
      // addDisabled: false,
      // addDisplay: false,
      // editDisplay: false,
      order: 997,
      props: {
        label: 'title',
      },
      // rules: [
      //   {
      //     required: false,
      //     message: '请选择上级代理商',
      //     trigger: 'click',
      //   },
      // ],
    },
    {
      label: '排序',
      prop: 'sort',
      type: 'number',
      display: false,
      align: 'right',
      addDisplay: false,
      editDisplay: false,
      width: 80,
      order: 996,
      hide: true,
      // rules: [
      //   {
      //     required: true,
      //     message: "请输入排序",
      //     trigger: "blur",
      //   },
      // ],
    },
    {
      label: '备注',
      prop: 'remark',
      type: 'textarea',
      maxlength: 300,
      span: 24,
      rules: [
        {
          required: false,
          message: '请输入备注',
          trigger: 'blur',
        },
      ],
      hide: true,
    },
    // {
    //   label: '扩展',
    //   prop: 'extend',
    //   hide: true,
    //   showColumn: false,
    //   formslot: true,
    //   span: 24,
    // },
  ],
}